import { connect } from 'react-redux';
import { has, map } from 'lodash';

import DataSetCardOverviewTab from './DataSetCardOverviewTab';
import { getFirstParentForDataset, getCurrentUser } from '../../../reducers/selectors';

import {
  loadDataSet,
  fetchDataSet,
  fetchDataSetUpdateTime,
  fetchResourceMetricsAggregate,
  fetchResourceMetricsPerDay,
  fetchDatasetDoc,
  updateDatasetDoc,
  addDatasetApiKey,
  submitToCatalog,
  generateSemanticSchema,
} from '../../../actions';
import { isDetectedDataset, getResourceApiKeys } from '../../../lib/ResourceUtils';
import { isReadOnly } from '../../../lib/ACLUtils';

const mapStateToProps = (state, ownProps) => {
  const {
    request,
    entities: { sources, users, sinks, apiKeys, docs },
    dataSets: { summaryById, docById },
    dataSetSchemas,
  } = state;

  const { data } = ownProps;
  const datasetApiKeys = getResourceApiKeys(data, apiKeys);

  const isDetected = isDetectedDataset(data);
  const source = data && isDetected ? sources[data?.data_source_id] : null;

  const dataSinks = data.dataSinks || map(data && data.data_sinks, (id) => sinks[id]);

  const parentDataset =
    data && isDetected === false ? getFirstParentForDataset(state, ownProps) : null;

  const currentUser = getCurrentUser(state);
  const sharedByUser =
    parentDataset && has(parentDataset, 'owner') ? users[parentDataset.owner] : null;
  const isDerivedFromExternalDataset =
    sharedByUser && sharedByUser.id !== currentUser.id ? true : false;

  let isDerivedFromMySource =
    isDerivedFromExternalDataset === false &&
    has(parentDataset, 'data_source_id') &&
    parentDataset.data_source_id !== null
      ? true
      : false;

  const readOnly = isReadOnly(data);

  const datasetSemanticInfo = data?.semantic_schema?.dataset_sensitivity;

  return {
    apiKeys: datasetApiKeys,
    isDetected,
    source,
    dataSinks,
    parentDataset,
    isDerivedFromExternalDataset,
    isDerivedFromMySource,
    isLoading: {
      dataset: request.GET_DATA_SET_REQUEST,
      //TODO: this is a hack... user will still see a loading on catalog briefly while dataset is being fetched for any other reason. ideally we should track catalog update request separately.
      catalogUpdate:
        request.REGISTER_DATASET_ON_CATALOG_REQUEST ||
        (request.GET_DATA_SET_REQUEST && !request.CREATE_RESOURCE_API_KEY_REQUEST) ||
        false,
      aggMetrics: request.GET_RESOURCE_METRICS_AGGREGATE_REQUEST || false,
      dayMetrics: request.GET_RESOURCE_METRICS_BY_DAYS_REQUEST || false,
      //TODO: this is a hack... user will still see a loading on catalog briefly while dataset is being fetched for any other reason. ideally we should track dataFeedAPI key request separately.
      dataFeedApiKey:
        request.CREATE_RESOURCE_API_KEY_REQUEST ||
        (request.GET_DATA_SET_REQUEST && !request.REGISTER_DATASET_ON_CATALOG_REQUEST) ||
        false,
      doc: request.GET_DATA_SET_DOC_REQUEST || false,
      generateSemanticSchema: request.GENERATE_SEMANTIC_SCHEMA_REQUEST || false,
    },
    summaryData: data && has(summaryById, data.id) ? summaryById[data.id] : null,
    doc: data && docById[data.id] && docs[docById[data.id]] ? docs[docById[data.id]].text : null,
    readOnly,
    datasetSemanticInfo,
  };
};

export default connect(mapStateToProps, {
  loadDataSet,
  fetchDataSet,
  fetchDataSetUpdateTime,
  fetchResourceMetricsPerDay,
  fetchResourceMetricsAggregate,
  fetchDatasetDoc,
  updateDatasetDoc,
  addDatasetApiKey,
  submitToCatalog,
  generateSemanticSchema,
})(DataSetCardOverviewTab);
